export type OverflowResult<T> = {
  visible: T[];
  remaining: number;
};

export function formatTagsOverflow(
  tags: readonly string[],
  max = 3,
): OverflowResult<string> {
  if (tags.length <= max) return { visible: [...tags], remaining: 0 };
  return { visible: tags.slice(0, max), remaining: tags.length - max };
}
